<template>
  <section class="shield-home s-contact">
    <ShieldHeader />

    <div class="container-wide">
      <div class="content">
        <ShieldNavigation />

        <div class="banner">
          
          <picture>
            <source
              media="(max-width: 480px)"
              srcset="../assets/shield-banners/shield-bios-banner-03-square.jpg"
              alt=""
            />
            <source
              media="(min-width:481px)"
              srcset="../assets/shield-banners/shield-bios-banner-03.jpg"
              alt=""
            />
            <img
              src="../assets/shield-banners/shield-bios-banner-03.jpg"
              alt=""
            />
          </picture>
        </div>

        <div class="copy">
          <h2>Your Request Has Been Sent</h2>
          <p>
              Your form has successfully been sent to staff at Shield Maintenance. 
          </p>
          <p>
            In the meantime, for immediate help call our main number at
            <a href="tel:+18177580470" class="telephone-link">(817) 754-0470</a>
            or Jacob on his cell phone at
            <a href="tel:+18174015990" class="telephone-link">(817) 401-5990</a
            >.
          </p>

        </div>
      </div>
    </div>

    <ShieldFooter />
  </section>
</template>

<script>
import ShieldHeader from "@/components/ShieldHeader.vue";
import ShieldNavigation from "@/components/ShieldNavigation.vue";
import ShieldFooter from "@/components/ShieldFooter.vue";

export default {
  name: "ShieldHome",
  components: {
    ShieldHeader,
    ShieldNavigation,
    ShieldFooter
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

.content {
  background: #fff;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #444;
}

a.telephone-link {
        text-decoration:none;
        color:#aa6b2c;

    @media screen and (max-width:$small-bp){
        border-bottom:1px dotted #aa6b2c;
    } 
}



</style>
